import { HttpInterceptor, HttpXsrfTokenExtractor, HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable()
export class XsrfInterceptor implements HttpInterceptor {

    constructor(
        private tokenExtractor: HttpXsrfTokenExtractor) {
    }

    private actions: string[] = ["POST", "PUT", "DELETE"];
    private forbiddenActions: string[] = ["HEAD", "OPTIONS"];

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        console.debug('XSRF Interceptor Begin: ', request.url);

        let token = this.tokenExtractor.getToken();
        let permitted = this.findByActionName(request.method, this.actions);
        let forbidden = this.findByActionName(request.method, this.forbiddenActions);

        if (permitted !== undefined && forbidden === undefined && token !== null) {
            console.debug('Applying anti-forgery token defence: ', request.url);
            
            let newHeaders = request.headers.append("X-XSRF-TOKEN", token);
            request = request.clone({ headers: newHeaders }); // Important: Must match custom defined header name in the backend
        }
        
        return next.handle(request);
    }

    private findByActionName(name: string, actions: string[]): string {
        return actions.find(action => action.toLocaleLowerCase() === name.toLocaleLowerCase());
    }
}